import { request } from './http'

/** 可用报告期列表（降序）：[{ period, source, count, updatedAt }] */
export function fetchFundPeriods() {
  return request('/api/fund-holdings/periods').then((data) => data.list || [])
}

/** 某报告期持仓明细（按基金家数降序） */
export function fetchFundHoldings(period) {
  return request(`/api/fund-holdings?period=${encodeURIComponent(period)}`).then((data) => data.list || [])
}
